<template>
    <div class="schoolRoadTeamPackageindex">
        <div class="top">
            <el-col :span="19">     
               <el-button type="primary" size="medium" @click="schoolRoadTeamPackageadd()">新增套餐</el-button>
                <el-select v-model="listQuery.state" placeholder="请选择类型" size="medium" @change="handleFilter()">
                    <el-option  :value="0"  label="全部套餐状态"></el-option>
                    <el-option  :value="1"  label="未使用"></el-option>
                    <el-option  :value="2"  label="已发货"></el-option>
                    <el-option  :value="3"  label="已使用"></el-option>
                </el-select>  
            </el-col>
            <el-col :span="5">
                <el-input size="medium"  placeholder="请输入学校名称" v-model.trim="listQuery.searchTitle" @change="handleFilter">
                  <el-button size="medium" slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
                </el-input>
            </el-col>
        </div>	
        <el-table stripe :data="dataList"  :height="`${windowHeight-220}px`" border style="width: 100%" >
             <el-table-column  label="SN" show-overflow-tooltip  >
                <template slot-scope="scope">
                    <span class="link-type" @click="schoolRoadTeamPackageinfo(scope.row.equipmentId)"> {{scope.row.equipmentId}}</span>                   
                </template>
            </el-table-column>  
             <el-table-column label="设备类型" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                        {{scope.row.equipTypeName?scope.row.equipTypeName:'----'}}
                </template>
            </el-table-column> 
            <el-table-column label="使用场景" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                        {{scope.row.useTypeName?scope.row.useTypeName:'----'}}
                </template>
            </el-table-column> 
            <el-table-column label="学校类型" align="center" >
                <template slot-scope="scope">
                    <span v-if="scope.row.schoolType==2">小学</span>
                     <span v-if="scope.row.schoolType==3">初中</span>
                </template>
            </el-table-column> 
            <el-table-column label="放学卡" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                        {{scope.row.cardCount?scope.row.cardCount:'----'}}
                </template>
            </el-table-column> 
             <el-table-column align="center"  label="状态" width="100" >
                <template slot-scope="scope">
                    <el-tag  size="mini" type="info" v-if="scope.row.state==1">未使用</el-tag>
                    <el-tag  size="mini" type="success" v-if="scope.row.state==2">已发货</el-tag>
                    <el-tag  size="mini"  v-if="scope.row.state==3">已使用</el-tag>
                </template>
            </el-table-column> 
             <el-table-column label="发货人" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                        {{scope.row.consignorUserName?scope.row.consignorUserName:'----'}}
                </template>
            </el-table-column> 
             <el-table-column label="备注" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                        {{scope.row.consignorRemark?scope.row.consignorRemark:'----'}}
                </template>
            </el-table-column> 
             <el-table-column label="绑定学校" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                        {{scope.row.schoolName?scope.row.schoolName:'----'}}
                </template>
            </el-table-column> 
             <el-table-column label="绑定时间" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                        {{scope.row.bindTime?scope.row.bindTime.substring(0, 19):'----'}}
                </template>
            </el-table-column>
              <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                         <el-button v-if="scope.row.state==1"  @click.native.prevent="dialogVisiblefun(scope.row.equipmentId)"  type="text" size="small">发货</el-button>
                         <el-button v-if="scope.row.state==1"  @click.native.prevent="schoolRoadTeamPackageeidt(scope.row.equipmentId)"  type="text" size="small">编辑</el-button>
                         <el-button  @click.native.prevent="delSchooloverCombo(scope.row.equipmentId)"  type="text" size="small">删除</el-button>
                    </template>
            </el-table-column> 
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>

     <el-dialog title="发货" :close-on-press-escape='false' :close-on-click-modal='false' :visible.sync="dialogVisible" width="700px" :lock-scroll="false" :modal-append-to-body='false'>
			<el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="运单号" prop="consignorNum">
            <el-input v-model.trim="formData.consignorNum"  :maxlength="30" placeholder="请输入运单号"></el-input>
          </el-form-item>
          <el-form-item label="发货备注" prop="consignorRemark">
            <el-input v-model.trim="formData.consignorRemark"  type="textarea" :rows="2" :maxlength="100" placeholder="请输入发货备注"></el-input>
          </el-form-item>
        </el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="consignorSchooloverCombo()">确 定</el-button>
			</span>
		</el-dialog>

    </div>
</template>
<script>
    import {consignorSchooloverCombo,delSchooloverCombo,getSchooloverComboList} from '@/api/schoolRoadTeamPackage';
    import {findDicsByCode} from '@/api/common/common';
    import mixin from '@/mixins/windowResize';
    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    searchTitle: '',
                    state:0,
                    useType:0
                },
                dataList: [],
                total: null,
                formData:{
                    consignorNum:"",
                    consignorRemark:"",
                    equipmentId:""
                },
                dialogVisible:false,
                rules: {
                   consignorNum: [{ required: true, trigger: 'blur', message: '请输入运单号' }],
                   consignorRemark: [{ required: true, trigger: 'blur', message: '请输入发货备注' }],
                },         
            }
        },
        created() {
            this.queryFoodLists();
        },
        mixins: [mixin],       
        methods: {   
            dialogVisiblefun(equipmentId){
              this.dialogVisible=true;
              this.formData.equipmentId=equipmentId
            },
            delSchooloverCombo(id){
               this.$confirm('是否删除?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delSchooloverCombo(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.queryFoodLists();
                    }).catch();

                }).catch(() => {
                });
            },    
            //获取列表          
            queryFoodLists() {
                getSchooloverComboList(this.listQuery)
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    }).catch(err => {
                })
            },
    consignorSchooloverCombo() {
      this.$refs['form'].validate(valid => {
        if (valid) {   
            consignorSchooloverCombo(this.formData)
            .then(res => {
              const data = res.data;
              if (data.result) {
                this.$message({
                  message: "发货成功！",
                  type: "success",
                  duration: 1000
                });
                this.queryFoodLists();
                 this.dialogVisible=false;
              }else{
                    this.$message({
                  message: data.msg,
                  type: "warning",
                  duration: 1000
                });
              }
            })
            .catch(err => {});
        } else {
          return false;
        }
      });
    },
            //搜索
            handleFilter (){
                this.listQuery.pageNo=1;
                this.queryFoodLists();
            }, 
            //切换码数          
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.queryFoodLists();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.queryFoodLists();
            },
            schoolRoadTeamPackageinfo(id){
                this.$router.push({
                    path: "schoolRoadTeamPackageinfo",
                     query:{
                        id:id
                    }
                });
            },
            schoolRoadTeamPackageeidt(id){
                this.$router.push({
                    path: "schoolRoadTeamPackageeidt",
                     query:{
                        id:id
                    }
                });
            },
            schoolRoadTeamPackageadd(){
                this.$router.push({
                    path: "schoolRoadTeamPackageadd"
                });
            },          
        }
    }
</script>
<style lang="scss" scoped>
.schoolRoadTeamPackageindex{
   padding:12px;
    .pagination-container {
        margin-top: 10px;
    }
    .top{
        padding-bottom: 10px;
        overflow: hidden;
    }
    .img{
      width: 30px;
      height: 30px;
    }
    .link-type{
            cursor: pointer;
            color: #409eff;
    }
    .top-box{
        width: 100%;
        height: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/schoolRoadTeamPackage/schoolRoadTeamPackageindex.vue